import React, {useCallback, useEffect} from 'react';
import { IGeneralButton } from './GeneralButton';
import GeneralButton from './GeneralButton';
import './MenuModal.css';
import { focusFirstElement } from '../../../misc/helpers';

const MenuModal = (props: IMenuModal) => {
	useEffect(() => {
		if(props.isActive){
			console.log('binded event')
			window.document.addEventListener('keydown', props.handleKey);
			focusFirstElement(props.handleKey);
		}
	}, [props.isActive, props.forceUpdate]);

	if (!props.isActive) return <div></div>;

	return (
		<div className="pause-modal-background modal-disable-select">
			<div className="modal-background-shadow">
				<div className="modal">
					{props.title &&
						<div className="modal-container-title" style={props.titleContainerStyle}>
							<p tabIndex={0}>{props.title}</p>
						</div>
					}
					<div className="modal-top-panel-container">
						{props.children}
					</div>
				</div>
			</div>
		</div>
	);
};

export default MenuModal;

export interface IMenuModal {
	isActive: boolean,
	title: string,
	children: any,
	titleContainerStyle?: any,
	handleKey: any
	forceUpdate?: any
}